// src/components/Header/ProfileDropdown.jsx
import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import '../Style/ProfileDropdown.css';

const ProfileDropdown = ({ user, onLogout }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation();

  // Close dropdown if user clicks outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="profile-dropdown-container" ref={dropdownRef}>
      <div className="profile-trigger" onClick={() => setIsOpen(!isOpen)}>
        {/* ✅ Show profile pic if available, fallback to letter */}
        {user?.profilePicUrl ? (
          <img
            src={user.profilePicUrl}
            alt="Profile"
            className="avatar-circle avatar-img"
            style={{ objectFit: 'cover' }}
          />
        ) : (
          <div className="avatar-circle">{user.firstName?.charAt(0).toUpperCase() || 'U'}</div>
        )}
        <i className={`chevron-icon ${isOpen ? 'up' : 'down'}`}></i>
      </div>

      {isOpen && (
        <div className="dropdown-menu">
          <p className="dropdown-email" title={user.email}>
            {user.email}
          </p>

          <Link to="/search" className="dropdown-item" onClick={() => setIsOpen(false)}>
            <i className="icon-search"></i> Find Friends
          </Link>

          <Link to="/settings" className="dropdown-item" onClick={() => setIsOpen(false)}>
            <i className="icon-settings"></i> Settings
          </Link>
          <Link
            to={`/profile/${user?.id}`}
            className={`dropdown-item ${location.pathname === `/profile/${user?.id}` ? 'active' : ''}`}
            onClick={() => setIsOpen(false)}
          >
            <i className="icon-user"></i> My Profile
          </Link>

          {/* <Link to="/service-request" className="dropdown-item" onClick={() => setIsOpen(false)}>
            <i className="icon-star"></i> Request a Service
          </Link> */}

          {user?.role === 'ROLE_ADMIN' && (
            <Link to="/admin" className="dropdown-item" onClick={() => setIsOpen(false)}>
              <i className="icon-star"></i> Admin Dashboard
            </Link>
          )}

          <hr />
          <button className="dropdown-item logout-btn" onClick={onLogout}>
            <i className="icon-logout"></i> Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfileDropdown;
